<script setup lang="ts">
import type {
	NavigationMenuContentEmits,
	NavigationMenuContentProps
} from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { NavigationMenuContent, useForwardPropsEmits } from 'reka-ui';
import { computed } from 'vue';

const props = defineProps<
	NavigationMenuContentProps & { class?: HTMLAttributes['class'] }
>();

const emits = defineEmits<NavigationMenuContentEmits>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<NavigationMenuContent
		v-bind="forwarded"
		:class="
			cn('left-0 top-0 w-full bg-primary md:absolute md:w-auto', props.class)
		"
	>
		<slot />
	</NavigationMenuContent>
</template>
